import React from 'react';
import _SigninForm from './_SigninForm.scss';
import {Link} from 'react-router-dom';
import {Input} from 'components/vitrade-forms/common';
import {Auth} from 'api';
import {toastr} from 'react-redux-toastr';
import {login} from 'base/actions';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import FacebookLogin from 'base/lib/social-login/Facebook';
import {loginWithFacebook} from 'base/actions/social-login/facebook';

class SigninForm extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      email: '',
      password: '',
      remember: true
    }
  }

  facebookLoginCheck() {
    FB.login((fbLoginResponse) => {
      if (fbLoginResponse.status === 'connected') {
        this.props.dispatch(loginWithFacebook(fbLoginResponse.authResponse)).then(response => {
          this.setState({loading: false});

          if (response.isAuthenticated === true) {
            toastr.success('Thành công!', 'Bạn đã đăng nhập thành công.');

            // window.location = this.props.defaultPage;
            this.props.history.push(this.props.defaultPage);
          } else {
            toastr.error('Đăng nhập thất bại!', 'Có lỗi xảy ra. Bạn vui lòng thử lại');
          }
        });
      } else if (fbLoginResponse.status === 'not_authorized') {
        // The person is logged into Facebook, but not your app.
        // document.getElementById('status').innerHTML = 'Please log into this app.';
      } else {

      }
    }, {scope: 'email'});
  }

  statusChangeCallback(response) {
    // The response object is returned with a status field that lets the
    // app know the current login status of the person.
    // Full docs on the response object can be found in the documentation
    // for FB.getLoginStatus().
    if (response.status === 'connected') {
      // Logged into your app and Facebook.
      this.testAPI();
    } else if (response.status === 'not_authorized') {
      // The person is logged into Facebook, but not your app.
      // document.getElementById('status').innerHTML = 'Please log into this app.';
    } else {
      // The person is not logged into Facebook, so we're not sure if
      // they are logged into this app or not.
      // document.getElementById('status').innerHTML = 'Please log into Facebook.';
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.auth && nextProps.auth.isAuthenticated) {
      // force to dashboard
      this.props.history.push(this.props.defaultPage);
    }
  }

  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    })
  }

  submitForm(e) {
    e.preventDefault();

    this.props.dispatch(login(this.state.email, this.refs.password.validator.input.value, this.state.remember)).then(response => {
      this.setState({loading: false});

      if (response.isAuthenticated === true) {
        toastr.success('Thành công!', 'Bạn đã đăng nhập thành công.');

        // window.location = this.props.defaultPage;
        this.props.history.push(this.props.defaultPage);
      } else {
        toastr.error('Đăng nhập thất bại!', 'Sai email hoặc mật khẩu.');
      }
    }).catch(err => {
      console.log(err)
    });
  }

  render() {
    return (
      <div className="signin-box">
        <div className="register-logo">
          <b>Đăng nhập</b>
        </div>

        <div className="register-box-body">
          <form onSubmit={this.submitForm.bind(this)}>
            <Input type="email" placeholder="Email..."
              className='has-feedback fg-custom'
              iconClassName='fa-at'
              value={this.state.email}
              onChange={this.onChange.bind(this, 'email')}
            />

            <Input type="password" placeholder="Mật khẩu..."
              className='has-feedback fg-custom'
              iconClassName='fa-unlock-alt'
              ref='password'
            />

            <button type="submit" className="btn btn-primary btn-block btn-flat btn-submit text-btn">ĐĂNG NHẬP</button>
            <div className="forgot-password">
              <Link className="user-link" to="/forgot-password">Quên mật khẩu?</Link>
            </div>
          </form>
          <div className="social-auth-links text-center">
            <hr className="hr-text" data-content="hoặc"/>
            <button type="button" className="btn btn-block btn-fb btn-flat text-btn" onClick={this.facebookLoginCheck.bind(this)}><i className="fa fa-facebook"></i> ĐĂNG NHẬP VỚI FACEBOOK</button>
          </div>
        </div>
        <div className="register-now">
          <p>Bạn chưa có tài khoản? <Link className="register-link" to="/signup"><b>Đăng ký ngay</b></Link></p>
        </div>
      </div>
    );
  }
}

SigninForm.defaultProps = {
  defaultPage: '/profile'
}

const bindStateToProps = state => {
  return {
    auth: state.appAuth
  }
}

export default withRouter(connect(bindStateToProps)(SigninForm));



// WEBPACK FOOTER //
// ./components/signin/SigninForm.jsx